import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
function ReviewsProfileComponent(props) {
  const {
    provider,
    show,
    classes: { colorBlock },
  } = props;
  return (
    provider.reviews &&
    provider.reviews.map(review => {
      // if (review.description.length > 0) {
        return (
          <Typography>
            <Rating
              readOnly
              name="individual-rating"
              precision={1}
              value={review.rating}
            />
            {'  '}

            <span key={review.id}>{review.description}</span>
          </Typography>
        );
      // }
    })||null
  );
}
const styles = theme => ({
  cardSection: {
    margin: '2em',
  },
  colorBlock: {},
});

export default withStyles(styles)(ReviewsProfileComponent);
